
import _cvat from 'cvat-core/src/api';
interface Sam2Params {
    job: string;
    cur_frame: number,
    points_list: string[]
}
export async function  sam2Model (funId: string, body: Sam2Params) {
    const cvat: any = _cvat;
    await cvat.lambda.sam2(funId, body)
}